// extracted by mini-css-extract-plugin
export default {"uploadIcon":"AddNewDocumentModal_uploadIcon__VDfTc","space":"AddNewDocumentModal_space__SRjh7"};